import React, { useEffect, useState } from "react";
import { Source, Layer, Marker } from "react-map-gl/mapbox";

const GpsPositionTrack = ({
  coordinates,
  color = "blue",
  width = 4,
  isPlay,
  actualPoint,
  setActualPoint,
  setfirtPoint,
  setLastPoint,
  speed,
  setActualInfo
}) => {
  const firstPoint = 0;

  useEffect(() => {
    console.log('entro aqui')
    setfirtPoint(0);
    let lastPoint = coordinates.length - 1;
    console.log(lastPoint);
    setLastPoint(lastPoint);
  }, []);

  useEffect(() => {
    if (!isPlay || coordinates.length === 0) return;
    //console.log(coordinates)
    let index = actualPoint;
    const interval = setInterval(() => {
      index += 1;
      if (index >= coordinates.length) {
        clearInterval(interval);
        return;
      }
      setActualPoint(index);
      setActualInfo(coordinates[index].timestamp.slice(11, 16))
    }, 10000 / speed);

    return () => clearInterval(interval);
  }, [isPlay, coordinates, speed, actualPoint]);

  const lineGeoJson = {
    type: "Feature",
    geometry: {
      type: "LineString",
      coordinates: coordinates.map((coord) => [
        coord.coor.longitude,
        coord.coor.latitude,
      ]),
    },
  };

  const lineLayer = {
    id: "track-line",
    type: "line",
    paint: {
      "line-color": ["to-color", color],
      "line-width": width,
    },
  };

  return (
    <>
      <Source id="track-line-source" type="geojson" data={lineGeoJson}>
        <Layer {...lineLayer} />
      </Source>

      {/* Punto en movimiento */}
      {coordinates[actualPoint] && (
        <Marker
          longitude={coordinates[actualPoint].coor.longitude}
          latitude={coordinates[actualPoint].coor.latitude}
          anchor="center"
        >
          <div className="w-4 h-4 bg-blue-500 rounded-full border-2 border-white shadow-lg" />
        </Marker>
      )}
    </>
  );
};

export default GpsPositionTrack;
